export enum FREEvent {
    Enabled = 'FRE Enabled',
}
